import { render, staticRenderFns } from "./RegistroCofins.vue?vue&type=template&id=97ecb414&scoped=true&"
import script from "./RegistroCofins.vue?vue&type=script&lang=js&"
export * from "./RegistroCofins.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ecb414",
  null
  
)

export default component.exports